<script setup>
</script>
<template>

    <Head>
        <title>Agenda Regulatoria</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Agenda Regulatoria</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-2 text-center text-md-left mb-4"><img :src="'/storage/' + seccion.imagen" alt="" loading="lazy" /></div>
                    <div class="col-lg-10 contenido-administrable text-center text-md-left" v-html="seccion.descripcion"></div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 col-md-8 p-0">
                        <div class="form-group">
                            <select class="form-control form__select" v-model="secretaria">
                                <option value="" :selected="secretaria == ''">Todas las Secretarías</option>
                                <option v-for="(item, i) in secretarias" :key="i" :value="item.id">{{ item.nombre }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 p-0 pl-md-2 pl-lg-2">
                        <button type="button" @click="" class="boton-principal boton-flecha">Filtrar</button>
                    </div>
                </div>
                <div>
                    <div v-for="(periodo, index) in groups" :key="index">
                        <div class="bloque-general__encabezado">
                            <h2>{{ periodo }}</h2>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-3 col-12 mb-5" v-for="(item, index) in filterPeriodo(periodo)" :key="index">
                                <div class="item">
                                    <div class="text p-4">
                                        <div class="titulo font-weight-bold">{{ item.nombre }}</div>
                                        <div class="secretaria mb-3 mt-3">{{ item.secretaria.nombre }}</div>
                                        <div class="row datos">
                                            <div class="col-6">
                                                <span class="font-weight-bold">Fecha:</span> <br><span class="">{{ $filters.getDate(item.fecha_presentacion) }}</span>
                                            </div>
                                            <div class="col-6 text-right">
                                                <span class="font-weight-bold">Acción</span>: <br><span class="">{{ item.accion }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="action p-3">
                                        <button type="button" @click="openModal(item)" class="boton-secundario boton-flecha">Mas Info</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal size="xl" scrollable centered hide-footer v-model="modalShow">
            <div class="content">
                <h2 class="title mb-0 font-weight-bold ">{{ currItem?.nombre }}</h2>
                <div class="secretaria">{{ currItem.secretaria?.nombre }}</div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="line font-weight-bold">Fecha de presentación: <span class="font-weight-normal">{{ $filters.getDate(currItem?.fecha_presentacion) }}</span></div>
                        <div class="line font-weight-bold">Acción a realizar: <span class="font-weight-normal">{{ currItem?.accion }}</span></div>
                        <div class="line font-weight-bold">Período: <span class="font-weight-normal">{{ currItem?.periodo }}</span></div>
                        <div class="line font-weight-bold">Código: <span class="font-weight-normal">{{ currItem?.codigo }}</span></div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="line font-weight-bold">Nombre preliminar de la Propuesta Regulatoria:
                            <span class="font-weight-normal">{{ currItem?.nombre }}</span>
                        </div>
                        <div class="line font-weight-bold">Materia sobre la que versará la Regulación:
                            <span class="font-weight-normal">{{ currItem?.materia }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12 font-weight-bold mb-0">Problemáticas que se pretende resolver con la Propuesta Regulatoria Justificación:</div>
                    <div class="col-12" v-html="currItem?.problematicas"></div>
                </div>

                <div class="row" v-if="currItem?.archivo != ''">
                    <div class="col-12 text-center mt-4 m-b-2">
                        <a :href="route('agenda.download', currItem?.id) + '?' + Math.ceil(Math.random() * 1000000)" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            secretaria: '',
            currItem: { id: 0 },
            modalShow: false,
        }
    },
    props: {
        seccion: Object,
        datos: Object,
        groups: Object,
        secretarias: Object,
    },
    methods: {
        filterPeriodo(periodo) {
            return this.filterBySecretaria(
                this.datos.filter((item) => item.periodo === periodo)
            )
        },
        filterBySecretaria: function (datos) {
            return this.secretaria
                ? datos.filter(
                    (item) => item.secretaria_id == this.secretaria
                )
                : datos;
        },
        openModal(item) {
            this.currItem = item;
            this.modalShow = true;
        },
        closeModal() {
            this.currItem = [];
            this.modalShow = false;
        }
    },
    compatConfig: { MODE: 3 }
}
</script>
<style scoped>
.bloque-general__encabezado {
    margin-top: 50px;
}

.boton-principal{
    height: 50px;
    padding: 1px 31px;
}

h2 {
    margin-top: 0;
}

.boton-secundario {
    padding: 8px 20px;
    font-size: 16px;
}

.item {
    height: 100%;
    font-size: 1.0625rem;
    background: #FFFFFF;
    box-shadow: .125rem .125rem .625rem 0 rgba(0, 0, 0, 0.23);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.item .text {
    line-height: 1.3rem;
    text-align: left;
}

.item .text .titulo {
    line-height: 1.3em;
    font-weight: bold;
}

.secretaria {
    font-family: "Playfair Display", Georgia, serif;
    font-style: italic;
    font-weight: 500;
    color: #555555;
    font-size: 16px;
    line-height: 20px;
}

.content .secretaria {
    font-size: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #535353;
}

.content h2 {
    margin: 0;
    line-height: 1.3em;
}

.item .text .datos {
    font-size: 14px;
}

.line {
    border-bottom: 1px solid #dfdfdf;
    padding-top: 5px;
    padding-bottom: 5px;
}

.item .action {
    background: #F9F9F9;
    text-align: center;
}
</style>
